import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Forbidden, LightButton, TextInputPreview } from '../../../components';

import styles from '../Modals.module.css';

export const DetalleInmunoterapiaModal = ({ data, hide }) => {

    const { permisos } = useSelector(state => state.auth);

    return (permisos.inmunoterapiaRead) ? (
        <div>
            <div className="row mb-3">
                <div className="col">
                    <div className={styles.modalHeader}>Detalles</div>
                </div>
            </div>
            <div className="row">
                {(typeof data.tipo !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label="Inmunoterapia"
                        name="tipo"
                        value={data.tipo}
                    />
                </div>
                }
                {(typeof data.alergenos !== 'undefined' && data.alergenos.length > 0) &&
                <div className="col-md-12 col-lg-9">
                    <TextInputPreview
                        label="Alérgenos"
                        name="alergenos"
                        value={data.alergenos.map(aler => aler.nombre).join(', ')}
                    />
                </div>
                }
            </div>
            <div className="row">
                {(typeof data.fase !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label="Fase"
                        name="fase"
                        value={data.fase}
                    />
                </div>
                }
                {(typeof data.identificador !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label="Frasco"
                        name="frasco"
                        value={data.identificador}
                    />
                </div>
                }
                {(typeof data.concentracion !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label="Concentración"
                        name="concentracion"
                        value={data.concentracion}
                    />
                </div>
                }
                {(typeof data.volumenAlergeno !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label={`Vol. alérgeno (${ (typeof data.tipoDosis !== 'undefined') ? data.tipoDosis : '' })`}
                        name="volumenAlergeno"
                        value={String(data.volumenAlergeno)}
                    />
                </div>
                }
            </div>
            <div className="row">
                {(typeof data.ultimaAplicacionFechaFormato !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label="Última apicación"
                        name="ultimaAplicacionFechaFormato"
                        value={data.ultimaAplicacionFechaFormato}
                    />
                </div>
                }
                {(typeof data.ultimaAplicacionDosis !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label={`Dosis (${ (typeof data.tipoDosis !== 'undefined') ? data.tipoDosis : '' })`}
                        name="ultimaAplicacionDosis"
                        value={String(data.ultimaAplicacionDosis)}
                    />
                </div>
                }
                {(typeof data.sitioAplicacion !== 'undefined' && typeof data.ultimaAplicacionLadoAplicacion !== 'undefined') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label={data.sitioAplicacion}
                        name="ladoAplicacion"
                        value={data.ultimaAplicacionLadoAplicacion}
                    />
                </div>
                }
                {(typeof data.ultimaAplicacionReaccion !== 'undefined' && data.ultimaAplicacionReaccion !== '') &&
                <div className="col-md-12 col-lg-3">
                    <TextInputPreview
                        label="Reacción"
                        name="reacción"
                        value={data.ultimaAplicacionReaccion}
                    />
                </div>
                }
            </div>
            {(typeof data.comentarios !== 'undefined' && data.comentarios !== '') &&
            <div className="row">
                <div className="col">
                    <TextInputPreview
                        label="Comentarios"
                        name="comentarios"
                        value={data.comentarios}
                    />
                </div>
            </div>
            }
            <div className="row">
                <div className='col-xs-12 col-sm-12 col-md-6'></div>
                <div className="col-xs-12 col-sm-12 col-md-6">
                    <LightButton
                        block={true}
                        icon="X"
                        marginTop={false}
                        onClick={ hide }
                        text="Cerrar"
                        type="button"
                    />
                </div>
            </div>
        </div>
    ) : <Forbidden />
}

DetalleInmunoterapiaModal.propTypes = {
    data: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired
}